<form [formGroup]="formInfosAddColaborador" (ngSubmit)="submitForm(formInfosAddColaborador)">
  <div class="card-content">
    <div class="card-holder --newBrand">
      <p class="card-holder-label" data-test="editLabelAdmissionDate">Data de admissão:</p>
      <div class="card-holder-input">
        <p class="card-holder-input">
          <input class="input-edit --dark" data-test="editValueAdmissionDate" [textMask]="{mask: dateMask}" formControlName="date" type="text" [ngClass]="{'--error' : formInfosAddColaborador.get('date').hasError('pastDate') && formInfosAddColaborador.get('date').touched}">
        </p>
        <p class="card-holder-error" *ngIf="formInfosAddColaborador.get('date').hasError('pastDate') && formInfosAddColaborador.get('date').touched">A data de emissão deve ser anterior ou igual à data de hoje.</p>
      </div>
    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="editLabelEmployeeCode">Número de matrícula:</p>
        <p class="card-holder-input"><input class="input-edit --dark" data-test="editValueEmployeeCode" formControlName="employeeCode" type="text"></p>
    </div>
    <div class="card-holder --newBrand">
      <p class="card-holder-label" data-test="editLabelEmployeeCode">Líder:</p>
      <p class="card-holder-input"><input class="input-edit --dark" data-test="editValueLeader" formControlName="leaderName" type="text"></p>
  </div>
  <div class="card-holder --newBrand">
    <p class="card-holder-label" data-test="editLabelEmployeeCode">E-mail do líder:</p>
    <p class="card-holder-input"><input class="input-edit --dark" data-test="editValueLeaderEmail" formControlName="leaderEmail" type="text"></p>
</div>
  </div>
  <div class="card-footer">
    <button class="button-default button-link" type="button" data-test="btnCancelInfosAdd" (click)="cancel($event)">Cancelar</button>
    <button class="button-default button-confirm" type="submit" data-test="btnSaveInfosAdd" [disabled]="!formInfosAddColaborador.valid && formInfosAddColaborador.get('date').touched || submittingForm">Salvar</button>
  </div>
</form>
